<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive"
               matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Account</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Account:</span>
          <a *ngIf="hasEditAccess" [routerLink]="[row.id]">
            {{ row.name }}
          </a>
          <span *ngIf="!hasEditAccess">{{ row.name }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="display">
        <mat-header-cell *matHeaderCellDef mat-sort-header="display">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          {{ row.display }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="allAgents">
        <mat-header-cell *matHeaderCellDef mat-sort-header="allAgents">Agents</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Agents:</span>
          {{ row.allAgents }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="accountType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="accountType">Group Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Group Type:</span>
          {{ row.accountType === 'acds' ? 'Agents Group' : row.accountType === 'hunts' ? 'Hunt Group' : row.accountType }}
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
